import { contrastRatio, ensureContrast } from './colorUtils';

const toHexIfRgba = value => {
  if (!value || value[0] === '#') return value;

  const match = value.match(/rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (!match) return value;

  const [r, g, b] = match.slice(1, 4).map(Number);
  return `#${[r, g, b]
    .map(channel => channel.toString(16).padStart(2, '0'))
    .join('')}`;
};

export const enforceContrast = tokens => {
  const nextTokens = {
    ...tokens,
    text: { ...tokens.text },
    primary: { ...tokens.primary }
  };

  const paper = toHexIfRgba(tokens.background.paper);
  const page = toHexIfRgba(tokens.background.default);

  const primaryMain = toHexIfRgba(tokens.primary.main);
  const primaryTextCandidate = toHexIfRgba(tokens.primary.contrastText) || '#ffffff';

  const textPrimary = toHexIfRgba(tokens.text.primary) || '#101323';
  const textSecondary = toHexIfRgba(tokens.text.secondary) || '#33405f';

  nextTokens.text.primary = ensureContrast({
    foreground: textPrimary,
    background: paper,
    minRatio: 7,
    darkenFirst: true
  });

  nextTokens.text.secondary = ensureContrast({
    foreground: textSecondary,
    background: paper,
    minRatio: 4.5,
    darkenFirst: true
  });

  nextTokens.primary.main = ensureContrast({
    foreground: primaryMain,
    background: page,
    minRatio: 3,
    darkenFirst: true
  });

  const primaryContrast = contrastRatio(primaryTextCandidate, nextTokens.primary.main);
  nextTokens.primary.contrastText = primaryContrast >= 4.5 ? primaryTextCandidate : '#ffffff';

  return nextTokens;
};

export default enforceContrast;
